<template>
    <CModal
        :model-value="props.modelValue"
        title="Pomoc s mentoringom"
        size="lg"
        @update:model-value="emit('update:modelValue', $event)"
    >
        <p class="mb-5 text-sm text-gray-600 dark:text-txt-body">
            Nevieš ako ďalej? Pozri si krátky video návod alebo nám napíš — radi ti pomôžeme.
        </p>

        <!-- Video tutorials — accordion: at most one open at a time -->
        <div class="flex flex-col gap-3">
            <div
                v-for="(tutorial, index) in tutorials"
                :key="tutorial.videoId"
                class="overflow-hidden rounded-2xl border border-gray-200 dark:border-default"
            >
                <button
                    type="button"
                    class="flex w-full cursor-pointer items-center gap-3 px-4 py-3 text-left transition-colors hover:bg-purple-50/60 dark:hover:bg-purple-900/20"
                    :aria-expanded="openIndex === index"
                    @click="toggle(index)"
                >
                    <span
                        class="flex size-9 shrink-0 items-center justify-center rounded-full bg-purple-100 text-purple-700 dark:bg-purple-900/50 dark:text-purple-300"
                        aria-hidden="true"
                    >
                        <Icon name="heroicons:play" class="size-4" />
                    </span>
                    <span class="flex-1 font-medium text-gray-900 dark:text-white">
                        {{ tutorial.title }}
                    </span>
                    <Icon
                        name="heroicons:chevron-down"
                        class="size-5 shrink-0 text-gray-400 dark:text-txt-body transition-transform"
                        :class="{ 'rotate-180': openIndex === index }"
                    />
                </button>
                <div v-if="openIndex === index" class="border-t border-gray-200 dark:border-default">
                    <CEmbedVideo :video-id="tutorial.videoId" :title="tutorial.title" responsive lite />
                </div>
            </div>
        </div>

        <!-- Contact block -->
        <div class="mt-6 rounded-2xl bg-gray-50 p-4 dark:bg-subtle/40">
            <p class="mb-3 text-sm text-gray-700 dark:text-txt-body">
                Stále nevieš ako ďalej? Napíš nám a pomôžeme ti.
            </p>
            <a
                href="mailto:karolina@growni.sk"
                class="inline-flex items-center justify-center gap-2 rounded-lg bg-purple-100 px-5 py-2.5 text-sm font-semibold text-purple-700 transition-colors hover:bg-purple-200 dark:bg-purple-900/50 dark:text-purple-300 dark:hover:bg-purple-900/70"
            >
                <Icon name="heroicons:envelope" class="size-4" />
                Napíš nám email
            </a>
        </div>
    </CModal>
</template>

<script setup lang="ts">
import CModal from '@/components/ui/CModal.vue'
import CEmbedVideo from '@/components/ui/CEmbedVideo.vue'

const props = defineProps<{
    modelValue: boolean
}>()

const emit = defineEmits<{
    'update:modelValue': [value: boolean]
}>()

// Order mirrors the user journey: profile → find mentor → get the most out of it.
const tutorials = [
    { title: 'Vyplň si profil', videoId: 'Lry5Gk6GCUw' },
    { title: 'Nájdi si mentora', videoId: 'AOdDue9sTgg' },
    { title: 'Vyťaž z mentoringu maximum', videoId: 'yj6AbM5JIrw' }
]

const openIndex = ref<number | null>(null)

const toggle = (index: number) => {
    openIndex.value = openIndex.value === index ? null : index
}
</script>
